import {Component, OnInit} from '@angular/core';
import {BreadcrumbsService} from '../../shared/components/breadcrumbs/breadcrumbs.service';

@Component({
    selector: 'kkk-bibleschool',
    templateUrl: './bibleschool.component.html',
    styleUrls: ['./bibleschool.component.scss']
})
export class BibleschoolComponent implements OnInit {
    constructor(
        private _breadcrumbs: BreadcrumbsService,
    ) {
    }

    ngOnInit() {
        this._breadcrumbs
            .start({name: 'Mit teszünk?', instructions: ['/mit-teszunk']})
            .add({name: 'Bibliaiskola'});
    }
}



// WEBPACK FOOTER //
// /Users/manuel/Development/kkk/frontend/src/app/what-we-do/bibleschool/bibleschool.component.ts